import { useEffect, useMemo } from 'react';

import { useLocation } from 'react-router-dom';
import { setFromApp, USER } from '../features/User/slice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../features/store';

export const useFrom = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { from } = useSelector((state: RootState) => state[USER]);

  const query = useMemo(() => new URLSearchParams(location.search), [location]);

  useEffect(() => {
    const from = query.get('from');

    if (from === 'app') {
      dispatch(setFromApp());
    }
  }, [dispatch, query]);

  return from;
};
